import axios from 'axios';
import { createCompatibilityContext } from '@/helpers/styleCompatibilityContext';
import { showCompatibility } from '@/helpers/styleCompatibility';
import { buildErrorMessage } from '@/helpers/httpErrorMessage';
import { message } from 'ant-design-vue';
import { isLaunchInProgressError } from '@/helpers/launchErrors';
import { isRenderRevisionChoiceError } from '@/helpers/renderRevisionChoice';
import config from '@/config'; // eslint-disable-line import/extensions

const showErrorMessage = (text) => {
  message.error({
    content: text,
    duration: 5,
  });
};

const isHandledByCaller = (error) => (error?.response?.status === 403 && error?.response?.data?.message)
  || isLaunchInProgressError(error)
  || isRenderRevisionChoiceError(error);

const handleResponseError = (error) => {
  if (error.config?.silent) throw error;

  if (isHandledByCaller(error)) {
    throw error;
  }

  const messageText = buildErrorMessage(error);

  if (messageText) {
    showErrorMessage(messageText);
  }

  if (error?.response?.status >= 500 && !error.config?.recoverable) {
    window.location.href = `/error?message=${encodeURIComponent(messageText)}`;
  }
  throw error;
};

export const createHttpClient = () => {
  const client = axios.create({
    baseURL: config.apiUrl,
    headers: { Accept: 'application/json' },
  });

  const compatibilityContext = createCompatibilityContext();
  client.interceptors.request.use(compatibilityContext.apply);
  client.interceptors.response.use((response) => {
    compatibilityContext.remember(response);
    if (response.config?.method !== 'get') {
      const checks = response.data?.compatibility;
      const check = response.data?.style_compatibility;
      if (Array.isArray(checks)) showCompatibility(checks);
      else if (check) showCompatibility([check]);
    }
    return response;
  }, handleResponseError);

  return client;
};

export const httpClient = createHttpClient();

export const fileDownloadConfig = {
  headers: { Accept: '*' },
  responseType: 'blob',
};
